"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var WithErrorHandler_1 = require("../../components/WithErrorHandler");
var request_1 = require("../../utils/request");
var baseModal_1 = __importDefault(require("./baseModal"));
var index_1 = require("../../utils/index");
var newcarCommonApis_1 = require("../../utils/newcarCommonApis");
var Index = function (props) {
    var titleRelate = react_1.useMemo(function () {
        return {
            mainTitle: typeof props.titleRelate !== 'undefined' && props.titleRelate.mainTitle || '查成交价',
            btnSubTitle: typeof props.titleRelate !== 'undefined' && props.titleRelate.btnSubTitle || '',
            btnMainTitle: typeof props.titleRelate !== 'undefined' && props.titleRelate.btnMainTitle || '查最低成交价'
        };
    }, [props.titleRelate]);
    var prodInfoRelate = react_1.useMemo(function () { return props.prodInfoRelate; }, [JSON.stringify(props.prodInfoRelate)]);
    var cityInfoRelate = react_1.useMemo(function () { return props.cityinfoRelate; }, [JSON.stringify(props.cityinfoRelate)]);
    var _a = __read(react_1.useState(false), 2), showTips = _a[0], setShowTips = _a[1];
    /** 询价成功之后的车型价格信息 */
    var _b = __read(react_1.useState(), 2), prodPriceData = _b[0], setProdPriceData = _b[1];
    /** 车型信息 */
    var _c = __read(react_1.useState(), 2), prodInfo = _c[0], setProdInfo = _c[1];
    var getProdInfo = react_1.useCallback(function (_a) {
        var _b = _a.productId, productId = _b === void 0 ? '' : _b, _c = _a.lineId, lineId = _c === void 0 ? '' : _c, _d = _a.cityid, cityid = _d === void 0 ? '' : _d;
        return __awaiter(void 0, void 0, void 0, function () {
            var params, res, err_1;
            var _e;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        _f.trys.push([0, 2, , 3]);
                        params = {
                            cityId: cityid || ((_e = cityInfoRelate === null || cityInfoRelate === void 0 ? void 0 : cityInfoRelate.defaultCityInfo) === null || _e === void 0 ? void 0 : _e.cityid),
                            productId: productId,
                            lineId: lineId,
                        };
                        return [4 /*yield*/, index_1.tools.getProdInfos(__assign({}, params))];
                    case 1:
                        res = _f.sent();
                        if (res.code === 0 && res.entity.data) {
                            setProdInfo(res.entity.data);
                        }
                        else {
                            throw res;
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        err_1 = _f.sent();
                        console.log('获取车型信息失败-->', err_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    }, [prodInfoRelate, cityInfoRelate]);
    var onShowTips = react_1.useCallback(function () {
        setShowTips(true);
        setTimeout(function () {
            setShowTips(false);
        }, 2000);
    }, []);
    var renderMidSlot = function () {
        if (prodInfo && prodInfo.finalPriceText) {
            return react_1.default.createElement("div", { className: 'finalprice-price-wrap' },
                react_1.default.createElement("div", { className: 'price-inner' },
                    prodInfo.finalPriceText && react_1.default.createElement("div", { className: 'price-inner-text' }, prodInfo.finalPriceText),
                    react_1.default.createElement("div", { className: 'price-inner-tip' },
                        "\u63D0\u4EA4\u53EF\u67E5\u770B\u5B8C\u6574\u6700\u4F4E\u6210\u4EA4\u4EF7",
                        react_1.default.createElement("img", { className: 'about-icon', src: "//icon.xgo-img.com.cn/article/22052616/xinche-about.png", alt: "", onClick: onShowTips })),
                    showTips && react_1.default.createElement("div", { className: 'price-inner-tippop' }, "\u6700\u4F4E\u6210\u4EA4\u4EF7\u6765\u6E90\uFF1A\u8FD1\u671F\u8F66\u4E3B\u4E0A\u4F20\u771F\u5B9E\u8D2D\u8F66\u53D1\u7968\u4E2D\u88F8\u8F66\u4EF7\u683C")));
        }
        else {
            return react_1.default.createElement(react_1.default.Fragment, null);
        }
    };
    /** 需要监听到询价成功之后 获取到返回的信息来渲染 */
    var renderSucceddMid = function () {
        if (prodInfo && prodPriceData) {
            return (react_1.default.createElement("div", { className: 'order-success-wrap' },
                react_1.default.createElement("div", { className: 'order-prod' },
                    react_1.default.createElement("img", { src: prodInfo.guidePic, alt: "", className: 'order-prod-img' }),
                    react_1.default.createElement("div", { className: 'order-prod-info' },
                        react_1.default.createElement("div", { className: 'order-prod-info-linename' }, prodInfo.lineName),
                        react_1.default.createElement("div", { className: 'order-prod-info-showname' }, prodInfo.productName))),
                react_1.default.createElement("div", { className: 'order-price' },
                    react_1.default.createElement("div", { className: 'order-price-item' },
                        react_1.default.createElement("div", { className: 'order-price-item-title' }, "\u5382\u5546\u6307\u5BFC\u4EF7"),
                        react_1.default.createElement("div", { className: 'order-price-item-price' }, prodPriceData.showPriceFormat || 0)),
                    react_1.default.createElement("div", { className: 'order-price-item' },
                        react_1.default.createElement("div", { className: 'order-price-item-title' }, "\u8FD1\u671F\u6700\u4F4E\u6210\u4EA4\u4EF7"),
                        react_1.default.createElement("div", { className: 'order-price-item-price red' }, prodPriceData.finalPriceTrueFormat || 0)),
                    react_1.default.createElement("div", { className: 'order-price-item' },
                        react_1.default.createElement("div", { className: 'order-price-item-title' }, "\u9884\u4F30\u53EF\u780D\u4EF7"),
                        react_1.default.createElement("div", { className: 'order-price-item-price' },
                            prodPriceData.diffPrice || 0,
                            "\u5143")))));
        }
        else {
            return react_1.default.createElement(react_1.default.Fragment, null);
        }
    };
    var onSubmitSuccessFn = react_1.useCallback(function (data, result) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, new Promise(function (resolve, reject) { return __awaiter(void 0, void 0, void 0, function () {
                    var params, ajaxUrl, res, err_2;
                    var _a;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0:
                                if (!(result.entity && result.entity.data && result.entity.data.orderTag)) return [3 /*break*/, 5];
                                _b.label = 1;
                            case 1:
                                _b.trys.push([1, 3, , 4]);
                                params = {
                                    _type: 'finalPrice',
                                    productId: prodInfo && prodInfo.productId || '',
                                    cityId: cityInfoRelate && ((_a = cityInfoRelate.defaultCityInfo) === null || _a === void 0 ? void 0 : _a.cityid),
                                    orderTag: result.entity.data.orderTag
                                };
                                ajaxUrl = newcarCommonApis_1.apiList.getProdInfoApi;
                                return [4 /*yield*/, request_1.request(ajaxUrl, __assign({}, params), 'jsonp')];
                            case 2:
                                res = _b.sent();
                                if (res.code === 0 && res.entity && res.entity.data) {
                                    setProdPriceData(res.entity.data);
                                    resolve('');
                                }
                                else {
                                    throw res;
                                }
                                return [3 /*break*/, 4];
                            case 3:
                                err_2 = _b.sent();
                                reject(err_2);
                                console.log('err-->', err_2);
                                return [3 /*break*/, 4];
                            case 4: return [3 /*break*/, 6];
                            case 5:
                                reject('缺少orderTag');
                                _b.label = 6;
                            case 6: return [2 /*return*/];
                        }
                    });
                }); })];
        });
    }); }, [cityInfoRelate, prodInfo]);
    /** 根据车型信息去获取他的价格 */
    var onGetProdInfo = react_1.useCallback(function (prodinfo) {
        prodinfo && getProdInfo({
            productId: prodinfo.productId,
            lineId: prodinfo.lineId
        });
        if (typeof prodInfoRelate !== 'undefined' && typeof prodInfoRelate.selectProdCallback !== 'undefined') {
            prodInfoRelate.selectProdCallback(prodinfo);
        }
    }, [cityInfoRelate, prodInfoRelate]);
    /** 切换城市之后刷新车型价格 */
    var onSelectCity = react_1.useCallback(function (cityinfo) {
        cityinfo && getProdInfo({
            productId: prodInfoRelate.productId,
            lineId: prodInfoRelate.lineId,
            cityid: cityinfo.cid
        });
        if (typeof cityInfoRelate !== 'undefined' && typeof cityInfoRelate.selectedCityFn !== 'undefined') {
            cityInfoRelate.selectedCityFn(cityinfo);
        }
    }, [prodInfoRelate, cityInfoRelate]);
    return (react_1.default.createElement(baseModal_1.default, __assign({}, props, { titleRelate: __assign({}, titleRelate), midSlotNode: props.midSlotNode || renderMidSlot(), cityinfoRelate: __assign(__assign({ show: true }, props.cityinfoRelate || {}), { selectedCityFn: onSelectCity }), prodInfoRelate: __assign(__assign({}, prodInfoRelate), { showProdArea: true, selectProdCallback: onGetProdInfo }), submitRelate: __assign({ onSubmitSuccessFn: onSubmitSuccessFn }, props.submitRelate || {}), successRelate: __assign({ successMidSlot: renderSucceddMid(), successTitle: '查成交价', 
            // 传空字符串意味着不显示
            successSubTitle: '', showSuccessIcon: false }, props.successRelate || {}) })));
};
exports.default = WithErrorHandler_1.WithErrorHandler(react_1.memo(Index));
